/* tslint:disable */
/* eslint-disable */
/**
 * Publikator Ezbierky Application API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError, operationServerMap } from './base';

/**
 * 
 * @export
 * @interface PredpisItem
 */
export interface PredpisItem {
    /**
     * 
     * @type {string}
     * @memberof PredpisItem
     */
    'cislo'?: string;
    /**
     * 
     * @type {string}
     * @memberof PredpisItem
     */
    'nazov'?: string;
    /**
     * 
     * @type {string}
     * @memberof PredpisItem
     */
    'iri'?: string;
    /**
     * 
     * @type {string}
     * @memberof PredpisItem
     */
    'datumVyhlasenia'?: string;
}

/**
 * PredpisListExternalApi - axios parameter creator
 * @export
 */
export const PredpisListExternalApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Get list of 10 latest publikovany predpis.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPublikovanyPredpisList: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/publikacia/latest`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * PredpisListExternalApi - functional programming interface
 * @export
 */
export const PredpisListExternalApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = PredpisListExternalApiAxiosParamCreator(configuration)
    return {
        /**
         * Get list of 10 latest publikovany predpis.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLatestPublikovanyPredpisList(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<PredpisItem>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLatestPublikovanyPredpisList(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['PredpisListExternalApi.getLatestPublikovanyPredpisList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * PredpisListExternalApi - factory interface
 * @export
 */
export const PredpisListExternalApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = PredpisListExternalApiFp(configuration)
    return {
        /**
         * Get list of 10 latest publikovany predpis.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLatestPublikovanyPredpisList(options?: any): AxiosPromise<Array<PredpisItem>> {
            return localVarFp.getLatestPublikovanyPredpisList(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * PredpisListExternalApi - object-oriented interface
 * @export
 * @class PredpisListExternalApi
 * @extends {BaseAPI}
 */
export class PredpisListExternalApi extends BaseAPI {
    /**
     * Get list of 10 latest publikovany predpis.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PredpisListExternalApi
     */
    public getLatestPublikovanyPredpisList(options?: RawAxiosRequestConfig) {
        return PredpisListExternalApiFp(this.configuration).getLatestPublikovanyPredpisList(options).then((request) => request(this.axios, this.basePath));
    }
}



